<ss-modal
  [open]="(modalOpen | async) ?? false"
  modalheight="fit-content"
  modalwidth="500px"
  (closeClick)="modalOpen.next(false)"
  [@modalAnimation]
>
  <svg
    closeButton
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-4 h-4 text-white"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
  <div
    class="flex flex-col justify-between h-full"
    [ssDirectus]="{
      collection: 'infoModal',
      item: modalData.id,
      fields: ['message', 'closeButtonText'],
    }"
  >
    <div
      class="p-4 text-center text-ss-brown"
      [innerHTML]="modalData.message"
    ></div>
    <div class="flex flex-row justify-center mx-3 mb-3">
      <ss-button
        (click)="modalOpen.next(false)"
        buttonStyle="filled"
        buttonColor="principal"
        >{{ modalData.closeButtonText }}</ss-button
      >
    </div>
  </div>
</ss-modal>
